module.exports = __webpack_public_path__ + "img/threeD-cover-3.a645865a.png";